import React from "react";

import AOS from "aos"; // Import AOS library
import NotFoundSec from "../sections/pageNotFound/NotFoundSec";
import Search from "../components/Search";
import PropertyFilter from "../components/PropertyFilter";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";

const PageNotFound = () => {
  React.useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
      />
      <PropertyFilter />
      <Search cusStyle={"filter-section-inner"} />
      <NotFoundSec title={t("opps")} desc={t("something_went_wrong")} />
    </>
  );
};

export default PageNotFound;
